import config from '@/language/en/components/config';
import filters from '@/language/en/components/filters';
import models from '@/language/en/components/cards/models';
import filter from '@/language/en/components/filter';
import post from '@/language/en/components/post';
import PublishSwitch from '@/language/en/components/PublishSwitch';
import Impress from '@/language/en/components/Impress';
import OperatorsLogs from '@/language/en/components/OperatorsLogs';
import CopyToClipboard from '@/language/en/components/CopyToClipboard';
import AddCardModal from '@/language/en/components/AddCardModal';
import HiddenCardsModal from '@/language/en/components/HiddenCardsModal';
import RemoveCardModal from '@/language/en/components/RemoveCardModal';
import CardModal from '@/language/en/components/CardModal';
import DashCardsContainer from '@/language/en/components/DashCardsContainer';
import GlobalFilter from '@/language/en/components/GlobalFilter';
import GlobalFilterModal from '@/language/en/components/GlobalFilterModal';
import GlobalFilterSummary from '@/language/en/components/GlobalFilterSummary';
import Badge from '@/language/en/components/Badge';
import DashFilterBar from '@/language/en/components/DashFilterBar';
import AddDescriptionModal from '@/language/en/components/AddDescriptionModal';
import AnnotationTextCard from '@/language/en/components/AnnotationTextCard';
import MenuBar from '@/language/en/components/MenuBar';
import HelpButton from '@/language/en/components/HelpButton';
import PublicAccessModal from '@/language/en/components/PublicAccessModal';
import Onboarding from '@/language/en/components/Onboarding';
import EnvironmentInfo from '@/language/en/components/EnvironmentInfo';
import AnnotationImageCard from '@/language/en/components/AnnotationImageCard';
import FileImporter from '@/language/en/components/FileImporter';
import ImportHistory from '@/language/en/components/ImportHistory';
import TextFilter from '@/language/en/components/TextFilter';
import CustomerServiceRatings from '@/language/en/components/CustomerServiceRatings';
import OptionsButton from '@/language/en/components/OptionsButton';
import StatusTable from '@/language/en/components/StatusTable';
import UserMenu from '@/language/en/components/UserMenu';
import ComponentBuildModal from '@/language/en/components/ComponentBuildModal';
import BlipMessageVolumeInPeriod from '@/language/en/components/BlipMessageVolumeInPeriod';
import BlipEngagedAndNonEngagedContacts from '@/language/en/components/BlipEngagedAndNonEngagedContacts';
import BlipActiveMessagesByChannel from '@/language/en/components/BlipActiveMessagesByChannel';
import ConsolidatedCSATPieChart from '@/language/en/components/ConsolidatedCSATPieChart';
import BaseChannelPieChartOwnedEarned from '@/language/en/components/BaseChannelPieChartOwnedEarned';
import CustomErrorMessage from '@/language/en/components/CustomErrorMessage';
import GPTSuggestions from '@/language/en/components/GPTSuggestions';
import SentmentByTagTreeview from '@/language/en/components/SentmentByTagTreeview';
import LoversTable from '@/language/en/components/LoversTable';
import BlipActiveCampaignComponents from '@/language/en/components/BlipActiveCampaignComponents';
import BlipOpenTicketsTable from '@/language/en/components/BlipOpenTicketsTable';
import BlipMonitoringAttendantsTable from '@/language/en/components/BlipMonitoringAttendantsTable';
import BlipReportsTicketsInTime from '@/language/en/components/BlipReportsTicketsInTime';
import BlipMonitoringTeamsTable from '@/language/en/components/BlipMonitoringTeamsTable';
import BlipDeskComponents from '@/language/en/components/BlipDeskComponents';
import BlipReportsTable from '@/language/en/components/BlipReportsTable';
import InterestLovers from '@/language/en/components/InterestLovers';
import CommentSheetImporter from '@/language/en/components/CommentSheetImporter';
import BlipTagsMetricsTable from '@/language/en/components/BlipTagsMetricsTable';
import BlipWaitingTicketsTable from '@/language/en/components/BlipWaitingTicketsTable';
import AverageSACTimePieChart from '@/language/en/components/AverageSACTimePieChart';
import PerformanceByTimeMatrix from '@/language/en/components/PerformanceByTimeMatrix';
import PerformanceByChannel from '@/language/en/components/PerformanceByChannel';
import ImportPostTags from '@/language/en/components/ImportPostTags';
import GlobalFilterMenu from '@/language/en/components/GlobalFilterMenu';
import CallsIncomingAttended from '@/language/en/components/CallsIncomingAttended';
import AutoReload from '@/language/en/components/AutoReload';
import ChooseCardMenu from '@/language/en/components/ChooseCardMenu';
import DateFilter from '@/language/en/components/DateFilter';
import ResizeModal from '@/language/en/components/ResizeModal';
import DashTopBar from '@/language/en/components/DashTopBar';
import TopPosts from '@/language/en/components/TopPosts';
import PropTopPosts from '@/language/en/components/PropTopPosts';
import PropTopCommentsPosts from '@/language/en/components/PropTopCommentsPosts';
import TimelineProprietaryPosts from '@/language/en/components/TimelineProprietaryPosts';
import EngagementMatrix from '@/language/en/components/EngagementMatrix';
import SentimentByTagTreeviewFilter from '@/language/en/components/SentimentByTagTreeviewFilter';
import StockVsSentimentLineChart from '@/language/en/components/StockVsSentimentLineChart';
import StockVsSocialLineChart from '@/language/en/components/StockVsSocialLineChart';
import SacReportCallsQuantity from '@/language/en/components/SacReportCallsQuantity';
import MultiplePieChart from '@/language/en/components/MultiplePieChart';
import GranularityDropDown from '@/language/en/components/GranularityDropDown';
import VariationOfFanBaseChart from '@/language/en/components/VariationOfFanBaseChart';
import GoogleMyBusinessRatingsByStars from '@/language/en/components/GoogleMyBusinessRatingsByStars';

export default {
  config,
  filters,
  models,
  filter,
  post,
  PublishSwitch,
  CardModal,
  DashCardsContainer,
  CopyToClipboard,
  AddCardModal,
  HiddenCardsModal,
  RemoveCardModal,
  Impress,
  GlobalFilter,
  GlobalFilterModal,
  GlobalFilterSummary,
  OperatorsLogs,
  Badge,
  DashFilterBar,
  AddDescriptionModal,
  AnnotationTextCard,
  MenuBar,
  HelpButton,
  PublicAccessModal,
  Onboarding,
  EnvironmentInfo,
  AnnotationImageCard,
  FileImporter,
  ImportHistory,
  TextFilter,
  CustomerServiceRatings,
  OptionsButton,
  StatusTable,
  UserMenu,
  ComponentBuildModal,
  BlipMessageVolumeInPeriod,
  BlipEngagedAndNonEngagedContacts,
  BlipActiveMessagesByChannel,
  ConsolidatedCSATPieChart,
  BaseChannelPieChartOwnedEarned,
  CustomErrorMessage,
  GPTSuggestions,
  SentmentByTagTreeview,
  LoversTable,
  BlipActiveCampaignComponents,
  BlipReportsTicketsInTime,
  BlipDeskComponents,
  BlipReportsTable,
  InterestLovers,
  CommentSheetImporter,
  BlipOpenTicketsTable,
  BlipMonitoringAttendantsTable,
  BlipMonitoringTeamsTable,
  BlipTagsMetricsTable,
  BlipWaitingTicketsTable,
  AverageSACTimePieChart,
  PerformanceByTimeMatrix,
  PerformanceByChannel,
  ImportPostTags,
  GlobalFilterMenu,
  CallsIncomingAttended,
  AutoReload,
  ChooseCardMenu,
  DateFilter,
  ResizeModal,
  DashTopBar,
  TopPosts,
  PropTopPosts,
  PropTopCommentsPosts,
  TimelineProprietaryPosts,
  EngagementMatrix,
  SentimentByTagTreeviewFilter,
  StockVsSentimentLineChart,
  StockVsSocialLineChart,
  SacReportCallsQuantity,
  MultiplePieChart,
  GranularityDropDown,
  VariationOfFanBaseChart,
  GoogleMyBusinessRatingsByStars,
};
